import React, { Component } from "react";

class DynamicHexagon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hexagonStyle: {
        fill: "white",
        stroke: "black",
        strokeWidth: "2"
        // shapeRendering: "geometricPrecision"
      },
      isMouseOver: false
    };
    this.toggleMark = this.toggleMark.bind(this);
	this.showNumber = (this.props.NumberedBoard)? (this.props.number) : (null)

  }

// coloring a tile when it is clicked
  toggleMark = e => {

	// deselected -> mark and uncolor it if it is in the same color
    if (this.state.isMouseOver && this.state.hexagonStyle.fill==this.props.currentColor) {
      this.setState({
        hexagonStyle: {
          ...this.state.hexagonStyle,
          //strokeWidth: "5",
          fill: "white"
        }
      }, 
		//put the function inside setState to make sure it gets the updated states
		
		// sending to DynamicBoard the Hexagon number that was clicked and its color	
		()=> {this.props.HexagonState([this.props.number, this.state.hexagonStyle.fill]) },
	  );
      // selected - > color and mark
    } else if (this.state.isMouseOver ) {
      this.setState({
        hexagonStyle: {
          ...this.state.hexagonStyle,
          //strokeWidth: "5",
          fill: this.props.currentColor
		  }
		}, ()=> {this.props.HexagonState([this.props.number, this.state.hexagonStyle.fill]) }
		);
	  } 
  };

  trackMouseOver = e => {
    this.setState({ isMouseOver: true });
  };

  trackMouseLeave = e => {
    this.setState({ isMouseOver: false });
  };


  render() {
    return (
      <g
        transform={this.props.transform}
        onMouseEnter={this.trackMouseOver}
        onMouseLeave={this.trackMouseLeave}
        onClick={this.toggleMark}
      >
        <polygon
          id="hexagon"
          points= "60,70 90,50 120,70 120,100 90,120 60,100"
		  transform = "rotate (90 90 85)"
          style={this.state.hexagonStyle}
        />
        <text
          text-anchor="middle"
          x="90"
          y="93"
          font-size="25"
          style= { (this.state.hexagonStyle.fill === "black")?  {fill: "white"}: {fill: "black"} }
        >
          {(this.props.NumberedBoard)? (this.props.number) : (null)}
        </text>
      </g>
    );
  }
}

export default DynamicHexagon;
